import { AxiosResponse } from 'axios';

import apiClient from '../client';
import { CompanyDto } from 'interfaces/companies/company';
import { ApiResponseDto } from 'interfaces/apiResponse';
import { ViesCompanyDetailsDto, ViesLookupQuery } from 'interfaces/companies/vies';

interface ViesService {
  lookup(queryParams?: ViesLookupQuery): Promise<ViesCompanyDetailsDto>;
  sync(id: string): Promise<CompanyDto>;
}

const endpoints = {
  lookup: `/companies/vies-lookup`,
  sync: (id: string) => `/companies/${id}/vies-sync`,
};

export const viesService: ViesService = {
  lookup: async (queryParams?: ViesLookupQuery): Promise<ViesCompanyDetailsDto> => {
    const response: AxiosResponse<ApiResponseDto<ViesCompanyDetailsDto>> = await apiClient.get(endpoints.lookup, {
      params: { ...queryParams },
      paramsSerializer: { indexes: null },
    });

    if (response.data.errors) {
      throw new Error(response.data.errors!.map(error => error.message).join(', '));
    }

    return response.data.data!;
  },
  sync: async (id: string): Promise<CompanyDto> => {
    const response: AxiosResponse<ApiResponseDto<CompanyDto>> = await apiClient.put(endpoints.sync(id));

    if (response.data.errors) {
      throw new Error(response.data.errors!.map(error => error.message).join(', '));
    }

    return response.data.data!;
  },
};
